<template>
  <div class="c29-wrap">
    <section ref="print">
      <div class="title">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>{{ this.$moment(this.startDate).format("YYYY-MM-DD") }}</span>
            <span
              v-if="$parent.endTimeShow"
            >至{{ this.$moment(this.endDate).format("YYYY-MM-DD") }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: flex-end">
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
          </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <!-- <div class="queryDate">
      <span style="width: 80px" for>查询日期</span>
      <input v-model="startDate" type="date" @change="getData" />
      <label for>到</label>
      <input v-model="endDate" @change="getData" type="date" />
      </div>-->
      <!-- <div class="c16-head">
      <div>
        <div>打印日期：2020/12/25</div>
        <div style="font-size:18px;border-bottom:1px solid black;font-weight:600">名门大酒店：常州店</div>
        <div>操作员：管理员</div>
      </div>
      <div>
        <div>查询时间范围：{{ startDate }}-{{endDate}}</div>
        <div>C16 宾客结帐款区间汇总报表（收付）</div>
        <div>总页数：1，页码：1</div>
      </div>
      </div>-->
      <div class="report">
        <div class="PreArrivalItem" style="line-height:30px;border-top:1px solid black">
          <div class="zhanghao">账号</div>
          <div class="xingming">姓名</div>
          <div class="fanghao">房号</div>
          <div class="fangxing">账项</div>
          <div class="shijian3">发生时间</div>
          <div class="fangjia" style="text-align:right">金额</div>
          <div class="fangxing">操作员</div>
          <div style="text-align:left;padding-left:10px;flex:1">备注</div>
        </div>

        <div v-for="(item,index) in list" :key="index">
          <div v-for="(item2,index2) in item.list" :key="'a'+index2">
            <div class="PreArrivalItem">
              <div class="zhanghao">{{item2.accNo}}</div>
              <div class="xingming">{{item2.name}}</div>
              <div class="fanghao">{{item2.roomNo}}</div>
              <div class="fangxing">{{item2.chnName}}</div>
              <div class="shijian3">{{item2.createTime}}</div>
              <div class="fangjia" style="text-align:right">{{curreny(item2.amount)}}</div>
              <div class="fangxing">{{item2.userName}}</div>
              <div style="text-align:left;padding-left:10px;flex:1">{{item2.remark}}</div>
            </div>
          </div>
          <div class="PreArrivalItem" style="font-weight:bold">
            <div class="zhanghao"></div>
            <div class="xingming"></div>
            <div class="fanghao"></div>
            <div class="fangxing">{{item.chnName}}</div>
            <div class="shijian3">小计{{item.list.length}}笔</div>
            <div class="fangjia" style="text-align:right">{{curreny(item.total)}}</div>
            <div class="fangxing"></div>
            <div style="flex:1"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      startDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      endDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      list: [],
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.closeshow();
    this.$parent.bbmc = "C29.哑房账目查询报表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.startTimeShow = true;
    this.$parent.endTimeShow = true;
    this.$parent.showJzbs = true;
    this.$parent.showZx2 = true;
    this.$parent.ifSettle = "A";
    this.$parent.chaxunvib = true;

    this.getData();
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach() {
      if (new Date(this.$parent.startDate) <= new Date(this.$parent.endDate)) {
        this.getData();
      } else {
        this.$mymessage({
          content: "截止日期必须大于开始日期",
          type: "error",
          time: 3000,
          hasClose: true
        });
      }
    },
    getData() {
      let that = this;
      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("/reportFrontCash/selectListC29", {
        startDate: this.$parent.startDate,
        endDate: this.$parent.endDate,
        ifSettle: this.$parent.ifSettle,
        txnItem: this.$parent.zx2
      }).then(res => {
        
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          let list = JSON.parse(JSON.stringify(res.data));
          let list2 = list.filter((item, index, arr) => {
            return (
              index ==
              arr.findIndex((innerItem, innerIndex) => {
                return item.txnItem == innerItem.txnItem;
              })
            );
          });

          list2.forEach(item => {
            item.total = 0;
            list.forEach(item2 => {
              if (item.txnItem == item2.txnItem) {
                if (item.list) {
                  item2.list = null;
                  item.list.push(JSON.parse(JSON.stringify(item2)));
                  item.total += parseFloat(item2.amount);
                } else {
                  item2.list = null;
                  item.list = [JSON.parse(JSON.stringify(item2))];
                  item.total += parseFloat(item2.amount);
                }
              }
            });
          });
          this.list = list2;

          this.$store.state.preArrivalList = res.data;
          this.$store.state.preArrivalName = "C29.哑房账目查询报表";
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
    },
    curreny(data) {
      
      if (data == "NaN" || data == undefined) {
        return null;
      }
      data = Number(data).toFixed(2);
      return data;
    }
  }
};
</script>

<style scoped>
.reportTable {
  height: 100%;
  overflow: scroll;
}
.PreArrivalItem {
  border-bottom: 1px solid black;
  margin: 0;
}
.PreArrivalItem > div {
  border-right: 1px solid black;
}
.PreArrivalItem > div:nth-child(1) {
  border-left: 1px solid black;
}
</style>